import React from 'react';
import { Link } from 'react-router-dom';
import './JobCodeSection.css';

interface JobCodeSectionProps {
  /** The appointment's job code, as returned by the API. */
  jobCode: string | null;
  /** The linked client, used to explain and fix a missing code. */
  clientId: number | null;
}

/**
 * The Job Code / Deployment ID of an appointment, shown as its own section on
 * every appointment detail page.
 *
 * The code belongs to the client rather than the appointment — it is the
 * client's region letter and client number — so every appointment for a client
 * carries the same code, and a missing code is always fixed on the client page.
 */
const JobCodeSection: React.FC<JobCodeSectionProps> = ({ jobCode, clientId }) => (
  <section className="job-code-section">
    <h3 className="job-code-section-title">Job Code / Deployment ID</h3>
    {jobCode ? (
      <p className="job-code-section-value job-code">{jobCode}</p>
    ) : (
      <>
        <p className="job-code-section-value job-code-section-value--empty">—</p>
        <p className="job-code-section-hint">
          {clientId == null ? (
            'This appointment is not linked to a client record, so it has no job code.'
          ) : (
            <>
              Set a state on <Link to={`/client/${clientId}`}>the client record</Link> to generate a
              code.
            </>
          )}
        </p>
      </>
    )}
  </section>
);

export default JobCodeSection;
